import React from "react";
import { Accordion, Container, Row, Col } from "react-bootstrap";
import { title } from "../config/Config";

// img imports

import About_img from "../Assets/Images/about.jpg";

const features = [
    {
        icon: "bi-shield-check",
        text: "100% Herbal And Natural",
    },
    {
        icon: "bi-star-fill",
        text: "Trusted By Thousands",
    },
    {
        icon: "bi-bag-fill",
        text: "Doctor Formulated",
    },
    {
        icon: "bi-truck",
        text: "Fast Delivery Nation Wide",
    },
];

const Abouts = () => {
    return (
        <>
            <div className="about_main_sec2">
                <Container>
                    <Row>
                        <div className="about_main">
                            <h5>Empowering Health the Natural Way</h5>
                        </div>
                    </Row>
                </Container>
            </div>
            <div className="about_main">
                <Container>
                    <Row>

                        <Col lg={12}>
                            <div className="about_info">
                                <h5>About {title}</h5>
                                <p>At <strong>{title},</strong> we believe in the power of Ayurveda – a time-tested system of natural healing rooted in Indian tradition. Our goal is to bring balance to your body, mind, and spirit through personalized Ayurvedic treatments, authentic herbal remedies, and holistic wellness practices.</p>
                                <p>With a deep respect for nature and the human body, we use only pure, natural ingredients to promote healing from within. Whether you’re seeking relief from chronic issues or simply want to enhance your overall well-being, we are here to guide you on your journey to optimal health.</p>
                                <p>Join us in embracing Ayurveda – the science of life – and experience the harmony your body truly deserves.</p>
                            </div>
                        </Col>

                    </Row>
                </Container>
            </div>
            <div className="about_main2">
                <Container>
                    <Row>
                        <Col lg={12}>
                            <div className="about_info2">
                                <h5>Our Journey</h5>
                                <p>At {title}, our journey began with a vision to reconnect people with the timeless wisdom of Ayurveda in a way that fits modern life. Recognizing the need for authentic, natural healing solutions, we set out to create a brand grounded in tradition but designed for today’s world.From humble beginnings to growing a community passionate about holistic wellness, our path is fueled by dedication to purity, sustainability, and nurturing every individual’s health journey. We believe that true wellbeing comes from balance, care, and respect for nature’s gifts.</p>
                            </div>
                        </Col>

                    </Row>
                </Container>
            </div>

            <div className="about_mission">
                <Container>
                    <Row>
                        <Col lg={6}>
                            <div className="about_card">
                                <h5>Our Mission</h5>
                                <p>To provide safe and effective Ayurvedic skincare solutions that naturally lighten dark spots, even skin tone, and enhance your natural glow—using pure, time-tested ingredients without harmful chemicals. We are committed to nurturing your skin’s health with authenticity and care.</p>
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div className="about_card">
                                <h5>Our Vision</h5>
                                <p>To be the most trusted brand in natural skincare, empowering people worldwide to embrace radiant, healthy skin through the wisdom of Ayurveda—promoting beauty that comes from balance, purity, and respect for nature. </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div className="feature_sec">
                <Container>
                    <Row className="feature_row">

                        <div className="feature_h">
                            <h5>The {title} Promise</h5>
                        </div>

                        {features.map((item, i) => (
                            <Col lg={3} md={6} xs={12} key={i}>
                                <div className="feature_card">
                                    <div className="icon_box">
                                        <i className={`bi ${item.icon}`}></i>
                                    </div>
                                    <h4>{item.text}</h4>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </div>

            <div className="about_details">
                <Container>
                    <Row>
                        <div className="about_inner_main">
                            <Row>
                                <Col lg={6}>
                                    <div className="About_img">
                                        <img src={About_img} alt="about img" />
                                    </div>
                                </Col>
                                <Col lg={6}>
                                    <div className="About_wrapper2">
                                        <h5>The Essence of Our Products</h5>
                                        <p>
                                            {title}’s range is a tribute to the timeless science of Ayurveda, thoughtfully adapted for today’s lifestyle. Every product we create is a blend of tradition, purity, and purpose.
                                        </p>
                                        <p><strong>Crafted with Care:</strong> Each formulation is prepared in small batches to preserve potency and ensure exceptional quality.</p>
                                        <p><strong>Powered by Nature:</strong> We use only authentic, sustainably sourced Ayurvedic herbs and natural ingredients.</p>
                                        <p><strong>Safe & Gentle:</strong> Free from parabens, sulfates, GMOs, and harmful chemicals—dermatologically tested for your peace of mind.</p>
                                        <h6>Our key offerings include:</h6>
                                        <p><strong>Herbal Stress Relievers:</strong> Promote mental calmness and clarity.</p>
                                        <p><strong>Immunity Boosters:</strong> Strengthen your body’s natural defenses.</p>
                                        <p><strong>Energy Revitalizers:</strong> Restore stamina and everyday vitality.</p>
                                        <p><strong>Detox & Cleansing Blends:</strong> Purify, balance, and rejuvenate your system naturally.</p>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Row>
                </Container>
            </div>

            <div className="about_faq">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={8} md={10}>
                            <Accordion defaultActiveKey="0">

                                {/* 1 */}
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>
                                        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-accordion icon-plant" viewBox="0 0 20 20"><path d="M15.963 5.166a.5.5 0 0 1 .09.701L11.232 12.1a3.5 3.5 0 0 0-.732 2.142v3.486a.5.5 0 0 1-1 0v-3.487a4.5 4.5 0 0 1 .94-2.753l4.822-6.233a.5.5 0 0 1 .701-.09"></path><path d="M4.137 9.11a.5.5 0 0 0 .018.707l4.256 4.044A3.5 3.5 0 0 1 9.5 16.398V19.5a.5.5 0 0 0 1 0v-3.102a4.5 4.5 0 0 0-1.4-3.262L4.842 9.092a.5.5 0 0 0-.706.018"></path><path fill-rule="evenodd" d="M18.378 1.54c.055.75.095 1.787.027 2.867-.093 1.467-.375 2.85-.95 3.739-.738 1.138-1.767 1.754-2.744 2-1.02.256-1.864.087-2.251-.164-.845-.547-1.794-2.72-.296-5.032.553-.854 1.786-1.654 3.244-2.316a24 24 0 0 1 2.97-1.095M18.73.4a.465.465 0 0 1 .588.406c.15 1.485.417 5.659-1.024 7.883-1.774 2.738-5.004 3.023-6.378 2.132-1.375-.89-2.345-3.708-.591-6.415C12.767 2.181 17.2.814 18.73.4M1.162 6.236c.087.567.223 1.278.43 1.993.306 1.058.726 1.977 1.25 2.5.706.706 1.537.989 2.272 1.015.779.028 1.329-.229 1.528-.428.457-.457.853-2.13-.595-3.578-.496-.496-1.464-.888-2.639-1.155a18 18 0 0 0-2.246-.347M.57 5.188a.46.46 0 0 0-.49.517c.147 1.245.64 4.316 2.055 5.731 1.8 1.8 4.31 1.49 5.215.587.903-.904 1.184-3.212-.595-4.992C5.335 5.613 1.903 5.27.57 5.188"></path></svg>
                                       What makes {title} Skin Care products different from others?
                                    </Accordion.Header>
                                    <Accordion.Body>
                                      {title} products are made using 100% natural and Ayurvedic ingredients. They are free from harmful chemicals, parabens, and synthetic fragrances—making them safe and gentle for all skin types.
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* 2 */}
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>
                                        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-accordion icon-plant" viewBox="0 0 20 20"><path d="M15.963 5.166a.5.5 0 0 1 .09.701L11.232 12.1a3.5 3.5 0 0 0-.732 2.142v3.486a.5.5 0 0 1-1 0v-3.487a4.5 4.5 0 0 1 .94-2.753l4.822-6.233a.5.5 0 0 1 .701-.09"></path><path d="M4.137 9.11a.5.5 0 0 0 .018.707l4.256 4.044A3.5 3.5 0 0 1 9.5 16.398V19.5a.5.5 0 0 0 1 0v-3.102a4.5 4.5 0 0 0-1.4-3.262L4.842 9.092a.5.5 0 0 0-.706.018"></path><path fill-rule="evenodd" d="M18.378 1.54c.055.75.095 1.787.027 2.867-.093 1.467-.375 2.85-.95 3.739-.738 1.138-1.767 1.754-2.744 2-1.02.256-1.864.087-2.251-.164-.845-.547-1.794-2.72-.296-5.032.553-.854 1.786-1.654 3.244-2.316a24 24 0 0 1 2.97-1.095M18.73.4a.465.465 0 0 1 .588.406c.15 1.485.417 5.659-1.024 7.883-1.774 2.738-5.004 3.023-6.378 2.132-1.375-.89-2.345-3.708-.591-6.415C12.767 2.181 17.2.814 18.73.4M1.162 6.236c.087.567.223 1.278.43 1.993.306 1.058.726 1.977 1.25 2.5.706.706 1.537.989 2.272 1.015.779.028 1.329-.229 1.528-.428.457-.457.853-2.13-.595-3.578-.496-.496-1.464-.888-2.639-1.155a18 18 0 0 0-2.246-.347M.57 5.188a.46.46 0 0 0-.49.517c.147 1.245.64 4.316 2.055 5.731 1.8 1.8 4.31 1.49 5.215.587.903-.904 1.184-3.212-.595-4.992C5.335 5.613 1.903 5.27.57 5.188"></path></svg>
                                       Can I use these products if I have sensitive or acne-prone skin?
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        Yes, our skin care range is specially formulated to suit sensitive and acne-prone skin. However, we always recommend doing a patch test before full use.
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* 3 */}
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>
                                        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-accordion icon-plant" viewBox="0 0 20 20"><path d="M15.963 5.166a.5.5 0 0 1 .09.701L11.232 12.1a3.5 3.5 0 0 0-.732 2.142v3.486a.5.5 0 0 1-1 0v-3.487a4.5 4.5 0 0 1 .94-2.753l4.822-6.233a.5.5 0 0 1 .701-.09"></path><path d="M4.137 9.11a.5.5 0 0 0 .018.707l4.256 4.044A3.5 3.5 0 0 1 9.5 16.398V19.5a.5.5 0 0 0 1 0v-3.102a4.5 4.5 0 0 0-1.4-3.262L4.842 9.092a.5.5 0 0 0-.706.018"></path><path fill-rule="evenodd" d="M18.378 1.54c.055.75.095 1.787.027 2.867-.093 1.467-.375 2.85-.95 3.739-.738 1.138-1.767 1.754-2.744 2-1.02.256-1.864.087-2.251-.164-.845-.547-1.794-2.72-.296-5.032.553-.854 1.786-1.654 3.244-2.316a24 24 0 0 1 2.97-1.095M18.73.4a.465.465 0 0 1 .588.406c.15 1.485.417 5.659-1.024 7.883-1.774 2.738-5.004 3.023-6.378 2.132-1.375-.89-2.345-3.708-.591-6.415C12.767 2.181 17.2.814 18.73.4M1.162 6.236c.087.567.223 1.278.43 1.993.306 1.058.726 1.977 1.25 2.5.706.706 1.537.989 2.272 1.015.779.028 1.329-.229 1.528-.428.457-.457.853-2.13-.595-3.578-.496-.496-1.464-.888-2.639-1.155a18 18 0 0 0-2.246-.347M.57 5.188a.46.46 0 0 0-.49.517c.147 1.245.64 4.316 2.055 5.731 1.8 1.8 4.31 1.49 5.215.587.903-.904 1.184-3.212-.595-4.992C5.335 5.613 1.903 5.27.57 5.188"></path></svg>
                                       How long does it take to see visible results from these Ayurvedic products?
                                    </Accordion.Header>
                                    <Accordion.Body>
                                       Results may vary depending on your skin type and consistency of use. Typically, users notice a natural glow and improvement in skin texture within 2 to 4 weeks of regular use.
                                    </Accordion.Body>
                                </Accordion.Item>

                            </Accordion>
                        </Col>
                    </Row>
                </Container>
            </div>

        </>
    );
};
export default Abouts;
